import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_PERSONAL_ACCESS_TOKENS = `${ENDPOINT_BASE}/personal-access-tokens`
